import type { FC } from 'react'
import { Link, useMatch, useResolvedPath } from 'react-router-dom-v7'
import type { CmsLink } from '@/cms/interfaces/cmsLink'
import type { HeaderLinksPropsApi } from '../models'

interface NavSingleLinkProps {
    link: HeaderLinksPropsApi
    navItemRef?: (el: HTMLAnchorElement | null) => void
}

const useMatches = (url: string, isStrictMatch?: boolean) => {
    const resolved = useResolvedPath(url)
    const end = isStrictMatch ? url : url === '/'
    const match = useMatch({ path: resolved.pathname, end: end ? true : false })
    return match
}

export const NavPageLink: FC<NavSingleLinkProps> = ({ link, navItemRef }) => {
    const singlePageLink: CmsLink = link.singlePageLink

    const selectedClass: string = useMatches(singlePageLink?.url, true) ? ' selected' : ''

    if (!singlePageLink?.url) return null

    return (
        <Link
            to={singlePageLink.url}
            className={`nav-link ${selectedClass}`}
            target={singlePageLink.target}
            ref={navItemRef}
        >
            {link.primaryPageName}
        </Link>
    )
}
